const getters = {
    allocation: (state) => state.allocation,
    id: (state) => state.id,
    payroll: (state) => state.payroll,
    employee_payrol: (state) => state.employee_payrol,
    u_id: (state) => state.u_id,
    loading: state => state.loading
};

export default getters;